import * as stylex from '@stylexjs/stylex'
import { colors } from '../tokens/colors.stylex'

export const mnpColors = {
  brand: '#E797A1',
  primary50: '#FFFAF9',
  primary100: '#FFE8E9',
  primary200: '#F4BEC1',
  primary300: '#E797A1',
  primary400: '#DF7180',
  primary500: '#D54F65',
  primary600: '#CA304E',
  primary700: '#AB1E3F',
  primary800: '#8B1131',
  primary900: '#6C0625',

  secondary50: '#FFFAF9',
  secondary100: '#FFE8E9',
  secondary200: '#F4BEC1',
  secondary300: '#E797A1',
  secondary400: '#DF7180',
  secondary500: '#D54F65',
  secondary600: '#CA304E',
  secondary700: '#AB1E3F',
  secondary800: '#8B1131',
  secondary900: '#6C0625',
}

export const colorTheme = stylex.createTheme(colors, mnpColors)
